import { connect } from 'react-redux'
import AppErrors from './AppErrors'

const mapStateToProps = state => {
  return {
    errors: state.errors,
  }
}

export default connect(mapStateToProps)(AppErrors)


// WEBPACK FOOTER //
// ./src/modules/AppErrors/Container.js